import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { addressI } from 'app/core/interfaces/adress';
import { AuthService } from 'app/core/http/services/auth.service';
import { FormStateMatcher } from 'app/core/directives/form-validate';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'page-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
})
export class MapViewComponent implements OnInit {
  @Input() address: any;
  @Input() latLong: [number, number] = [0, 0];

  @Input() googleMapUrl?: string;
  public url = '';
  public zoom = 15;

  public loading = false;
  readonly mapStateMatcher = new FormStateMatcher('');

  constructor(
    private auth: AuthService,
    private router: Router,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    if (this.address == undefined) {
      this.address = <addressI>{};
    }
  }

  getUrl() {
    this.url = `https://maps.google.com/maps?q=${this.address.latitude},${this.address.longitude}&hl=es&z=${this.zoom}&output=embed`;
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  openGoogleMapsLocation() {
    const address = `${this.address.street}, ${this.address.cep}, ${this.address.number},  ${this.address.city}-${this.address.state}`;
    const encodedAddress = encodeURIComponent(address);
    const googleMapsUrl = this.googleMapUrl ?? `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

    window.open(googleMapsUrl, '_blank');
  }
}
